import { render, staticRenderFns } from "./DialogRemoveExamples.vue?vue&type=template&id=c90506bc"
import script from "./DialogRemoveExamples.vue?vue&type=script&lang=js"
export * from "./DialogRemoveExamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports